/* Capitol style — trang giỏ hàng (sections/gv-cart.liquid).
   - Nút − / + và ô số lượng: đổi số lượng tại chỗ (chờ 400ms khi bấm liên tục), thùng rác: xoá dòng.
   - Mã giảm giá: thêm / bỏ mã, báo lỗi khi mã không dùng được cho giỏ này.
   - Ước tính phí ship: hỏi bảng giá ship thật của cửa hàng theo quốc gia / bang / zip.
   - Mỗi lần giỏ đổi: vẽ lại khung giỏ hàng từ Shopify (Section Rendering) + báo cho icon giỏ hàng trên header. */
const once = new WeakSet();
let Ev = null;
try { Ev = (await import('@shopify/events')).CartLinesUpdateEvent || null; } catch (_) { Ev = null; }

const R = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
const url = (p) => R.replace(/\/$/, '') + p;
const money = (cents, cur) => {
  try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); }
  catch (_) { return '$' + (cents / 100).toFixed(2); }
};

function init(root) {
  if (!root || once.has(root)) return;
  once.add(root);
  const sid = root.dataset.section;
  const rid = root.id;
  // vùng đọc cho trình đọc màn hình: luôn lấy bản mới nhất (khung giỏ hàng được vẽ lại sau mỗi lần đổi)
  const say = (t) => { const live = document.getElementById(rid) && document.getElementById(rid).querySelector('[data-gvk-live]'); if (live) { live.textContent = ''; setTimeout(() => { live.textContent = t; }, 50); } };
  const timers = {};

  async function rerender(html, keep) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.getElementById(root.id);
    if (!next) { location.reload(); return null; }
    // giữ trạng thái đóng / mở của các khối xổ xuống + kết quả ước tính ship
    root.querySelectorAll('[data-gvk-keep]').forEach((d) => {
      const n = next.querySelector('[data-gvk-keep="' + d.dataset.gvkKeep + '"]');
      if (n) n.open = d.open;
    });
    if (keep && keep.focus) {
      const f = next.querySelector(keep.focus);
      root.replaceWith(next); init(next);
      if (f) { const g = document.getElementById(f.id); if (g) g.focus(); }
    } else { root.replaceWith(next); init(next); }
    return next;
  }

  function announce(action, lines, promise) {
    if (!Ev) return null;
    const d = Ev.createPromise ? Ev.createPromise() : null;
    if (!d) return null;
    root.dispatchEvent(new Ev({ action, context: 'cart', lines, promise: d.promise }));
    return d;
  }

  async function change(line, qty) {
    const row = root.querySelector('.gvk__row[data-line="' + line + '"]');
    const err = row && row.querySelector('[data-gvk-err]');
    if (err) { err.hidden = true; err.textContent = ''; }
    if (row) row.classList.add('is-busy');
    root.classList.add('is-busy');
    const deferred = announce(qty > 0 ? 'update' : 'remove', [{ id: row ? row.dataset.key : '', quantity: qty }]);
    try {
      const res = await fetch(url('/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity: qty, sections: sid, sections_url: location.pathname }),
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || json.status || json.errors) {
        const msg = json.description || json.message || json.errors || 'This quantity is not available.';
        if (deferred) deferred.resolve({ cart: undefined, detail: { didError: true, source: 'gv-cart' } });
        if (row) {
          row.classList.remove('is-busy');
          const inp = row.querySelector('[data-gvk-qin]');
          if (inp) inp.value = inp.defaultValue;
          if (err) { err.textContent = typeof msg === 'string' ? msg : 'This quantity is not available.'; err.hidden = false; }
        }
        root.classList.remove('is-busy');
        return;
      }
      if (deferred) {
        let c; try { c = Ev.createCartFromAjaxResponse(json); } catch (_) { c = undefined; }
        deferred.resolve({ cart: c, detail: { items: json.items, itemCount: json.item_count, source: 'gv-cart', didError: false } });
      }
      const html = json.sections && json.sections[sid];
      if (html) { await rerender(html); say(qty > 0 ? 'Cart updated' : 'Item removed'); }
      else location.reload();
    } catch (e) {
      if (deferred) deferred.resolve({ cart: undefined, detail: { didError: true, source: 'gv-cart' } });
      if (row) row.classList.remove('is-busy');
      root.classList.remove('is-busy');
      if (err) { err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; }
    }
  }

  function clampQty(inp, v) {
    const min = parseInt(inp.min, 10) || 1, step = parseInt(inp.step, 10) || 1, max = parseInt(inp.max, 10);
    if (isNaN(v)) v = min;
    if (v < 0) v = 0;
    if (v > 0 && v < min) v = min;
    if (v > 0 && step > 1) v = Math.max(min, Math.round(v / step) * step);
    if (!isNaN(max) && v > max) v = max;
    return v;
  }
  function queue(inp, delay) {
    const row = inp.closest('.gvk__row');
    const line = parseInt(row.dataset.line, 10);
    const v = clampQty(inp, parseInt(inp.value, 10));
    inp.value = v;
    clearTimeout(timers[line]);
    if (v === parseInt(inp.defaultValue, 10)) return;
    timers[line] = setTimeout(() => change(line, v), delay);
  }

  root.addEventListener('click', (e) => {
    const step = e.target.closest('[data-gvk-step]');
    if (step) {
      const inp = step.parentElement.querySelector('[data-gvk-qin]');
      const d = parseInt(step.dataset.gvkStep, 10) * (parseInt(inp.step, 10) || 1);
      let v = (parseInt(inp.value, 10) || 0) + d;
      const min = parseInt(inp.min, 10) || 1;
      if (v < min) v = min;
      inp.value = v;
      queue(inp, 400);
      return;
    }
    const rm = e.target.closest('[data-gvk-remove]');
    if (rm) {
      e.preventDefault();
      const row = rm.closest('.gvk__row');
      change(parseInt(row.dataset.line, 10), 0);
      return;
    }
    const ap = e.target.closest('[data-gvk-apply]');
    if (ap) { applyCode(); return; }
    const cx = e.target.closest('[data-gvk-code-remove]');
    if (cx) { setCodes(codes().filter((c) => c.toUpperCase() !== cx.dataset.gvkCodeRemove.toUpperCase()), null); return; }
    const est = e.target.closest('[data-gvk-estimate]');
    if (est) { estimate(est); return; }
  });
  root.addEventListener('change', (e) => { if (e.target.matches('[data-gvk-qin]')) queue(e.target, 0); });
  root.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    if (e.target.matches('[data-gvk-qin]')) { e.preventDefault(); queue(e.target, 0); }
    else if (e.target.matches('[data-gvk-code]')) { e.preventDefault(); applyCode(); }
    else if (e.target.matches('[data-gvk-zip]')) { e.preventDefault(); estimate(root.querySelector('[data-gvk-estimate]')); }
  });

  /* Nút thanh toán: tránh bấm 2 lần */
  const form = root.querySelector('.gvk__form');
  if (form) form.addEventListener('submit', (e) => {
    const b = root.querySelector('.gvk__checkout');
    if (e.submitter === b) { if (b.classList.contains('is-busy')) { e.preventDefault(); return; } b.classList.add('is-busy'); setTimeout(() => b.classList.remove('is-busy'), 5000); }
  });

  /* ---------- Mã giảm giá ---------- */
  const codes = () => (root.dataset.codes || '').split(',').map((c) => c.trim()).filter(Boolean);
  function codeErr(t) {
    const el = root.querySelector('[data-gvk-code-err]');
    if (!el) return;
    el.textContent = t || ''; el.hidden = !t;
  }
  async function setCodes(list, added) {
    codeErr('');
    root.classList.add('is-busy');
    try {
      const res = await fetch(url('/cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: list.join(','), sections: sid, sections_url: location.pathname }),
      });
      const json = await res.json();
      if (added) {
        const hit = (json.discount_codes || []).find((d) => d.code.toUpperCase() === added.toUpperCase());
        if (!hit || !hit.applicable) {
          // bỏ mã không dùng được rồi báo lỗi
          const clean = list.filter((c) => c.toUpperCase() !== added.toUpperCase());
          const r2 = await fetch(url('/cart/update.js'), {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: clean.join(','), sections: sid, sections_url: location.pathname }),
          });
          const j2 = await r2.json();
          const next = j2.sections && j2.sections[sid] ? await rerender(j2.sections[sid]) : null;
          const target = next || root;
          const inp = target.querySelector('[data-gvk-code]');
          if (inp) { inp.value = added; inp.focus(); }
          const el = target.querySelector('[data-gvk-code-err]');
          const msg = '"' + added.toUpperCase() + '" isn’t a valid offer code for this cart.';
          if (el) { el.textContent = msg; el.hidden = false; }
          say(msg);
          return;
        }
      }
      if (json.sections && json.sections[sid]) { await rerender(json.sections[sid]); say(added ? 'Offer code applied' : 'Offer code removed'); }
      else location.reload();
    } catch (e) {
      root.classList.remove('is-busy');
      codeErr('Something went wrong. Please try again.');
    }
  }
  function applyCode() {
    const inp = root.querySelector('[data-gvk-code]');
    const v = (inp && inp.value || '').trim();
    if (!v) { codeErr('Please enter an offer code.'); if (inp) inp.focus(); return; }
    const list = codes();
    if (list.some((c) => c.toUpperCase() === v.toUpperCase())) { codeErr('This offer code is already applied.'); return; }
    list.push(v);
    setCodes(list, v);
  }

  /* ---------- Ước tính phí ship ---------- */
  const cty = root.querySelector('[data-gvk-country]');
  const prov = root.querySelector('[data-gvk-prov]');
  const provWrap = root.querySelector('[data-gvk-prov-wrap]');
  function fillProv() {
    if (!cty || !prov) return;
    const opt = cty.options[cty.selectedIndex];
    let list = [];
    try { list = JSON.parse(opt && opt.dataset.provinces || '[]'); } catch (_) { list = []; }
    prov.innerHTML = '';
    list.forEach((p) => { const o = document.createElement('option'); o.value = p[0]; o.textContent = p[1]; prov.appendChild(o); });
    provWrap.hidden = list.length === 0;
  }
  if (cty) {
    let saved = null;
    try { saved = JSON.parse(sessionStorage.getItem('gvk-ship') || 'null'); } catch (_) { saved = null; }
    const want = saved && saved.country ? saved.country : 'United States';
    for (let i = 0; i < cty.options.length; i++) if (cty.options[i].value === want) { cty.selectedIndex = i; break; }
    fillProv();
    if (saved) {
      if (saved.province && prov) prov.value = saved.province;
      const z = root.querySelector('[data-gvk-zip]'); if (z && saved.zip) z.value = saved.zip;
    }
    cty.addEventListener('change', fillProv);
  }
  async function estimate(btn) {
    const box = root.querySelector('[data-gvk-rates]');
    const zip = root.querySelector('[data-gvk-zip]');
    if (!box || !cty) return;
    const addr = { country: cty.value, province: provWrap && !provWrap.hidden && prov ? prov.value : '', zip: (zip.value || '').trim() };
    try { sessionStorage.setItem('gvk-ship', JSON.stringify(addr)); } catch (_) {}
    const q = 'shipping_address[country]=' + encodeURIComponent(addr.country) + '&shipping_address[province]=' + encodeURIComponent(addr.province) + '&shipping_address[zip]=' + encodeURIComponent(addr.zip);
    btn.disabled = true;
    box.innerHTML = '<p>Getting rates…</p>';
    try {
      const pr = await fetch(url('/cart/prepare_shipping_rates.json?' + q), { method: 'POST' });
      if (!pr.ok) throw await pr.json().catch(() => ({}));
      let data = null;
      for (let i = 0; i < 12 && !data; i++) {
        const r = await fetch(url('/cart/async_shipping_rates.json?' + q));
        if (r.status === 200) { const j = await r.json(); if (j && j.shipping_rates) data = j; }
        else if (r.status === 422) throw await r.json().catch(() => ({}));
        if (!data) await new Promise((ok) => setTimeout(ok, 500));
      }
      const rates = data ? data.shipping_rates : [];
      if (!rates.length) { box.innerHTML = '<p>Sorry, no quotes are available for this order at this time.</p>'; resetShip(); return; }
      rates.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
      const ul = document.createElement('ul');
      rates.forEach((r) => {
        const li = document.createElement('li');
        const n = document.createElement('span'); n.textContent = r.presentment_name || r.name;
        const p = document.createElement('strong'); const c = Math.round(parseFloat(r.price) * 100); p.textContent = c === 0 ? 'FREE' : money(c, r.currency);
        li.append(n, p); ul.appendChild(li);
      });
      box.innerHTML = ''; box.appendChild(ul);
      setShip(rates[0]);
    } catch (err) {
      const msgs = [];
      if (err && typeof err === 'object') Object.keys(err).forEach((k) => { const v = err[k]; (Array.isArray(v) ? v : [v]).forEach((m) => msgs.push((k === 'zip' ? 'Zip ' : k === 'province' ? 'State ' : k === 'country' ? 'Country ' : '') + m)); });
      box.innerHTML = '';
      const p = document.createElement('p'); p.className = 'gvk__code-err'; p.textContent = msgs.length ? msgs.join('. ') : 'Sorry, no quotes are available for this order at this time.';
      box.appendChild(p); resetShip();
    } finally { btn.disabled = false; }
  }
  function setShip(rate) {
    const name = root.querySelector('[data-gvk-ship-name]'), amt = root.querySelector('[data-gvk-ship-amt]'), tot = root.querySelector('[data-gvk-total]');
    if (!name || !amt || !tot) return;
    const c = Math.round(parseFloat(rate.price) * 100);
    name.textContent = rate.presentment_name || rate.name;
    amt.textContent = c === 0 ? 'FREE' : money(c, rate.currency);
    tot.textContent = money(parseInt(tot.dataset.cents, 10) + c, rate.currency);
    say('Estimated shipping: ' + name.textContent + ' ' + amt.textContent);
  }
  function resetShip() {
    const tot = root.querySelector('[data-gvk-total]');
    if (tot) tot.textContent = money(parseInt(tot.dataset.cents, 10));
  }
}

function scan(r) { (r || document).querySelectorAll('[data-gvk]').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan()); else scan();
document.addEventListener('shopify:section:load', (e) => scan(e.target));
